<template>
  <v-row class="menu-box mx-0 pa-1" @click="categoryClicked(cat)">
    <v-col
      v-if="
        $store.state.menuImageAlignment != 'right' &&
          ($store.state.menuImageVisible == 'show' || ($store.state.menuImageVisible == 'auto' && cat.imageUri != ''))
      "
      class="menu-img-box pa-0"
    >
      <div v-if="cat.imageUri == '' && (cat.imageUris === undefined || cat.imageUris.length == 0)"></div>
      <div v-else>
        <img v-if="cat.imageUri !== undefined && cat.imageUri != ''" :src="cat.imageUri" />
        <div v-else-if="cat.imageUris !== undefined && cat.imageUris.length > 0">
          <v-carousel
            cycle
            :show-arrows="false"
            :interval="10000 + Math.floor(Math.random() * 10) * 1000"
            hide-delimiter-background
            hide-delimiters
          >
            <v-carousel-item
              :x-transition="Math.floor(Math.random() * 2) % 2 == 0 ? 'slide-x-transition' : 'slide-y-transition'"
              :transition="Math.floor(Math.random() * 2) % 2 == 0 ? 'slide-x-transition' : 'slide-y-transition'"
              v-for="(imageUri, imgIndex) in cat.imageUris"
              :key="imgIndex"
            >
              <img :src="imageUri" />
            </v-carousel-item>
          </v-carousel>
        </div>
        <div v-else></div>
      </div>
    </v-col>

    <v-col class="menu-content-box pa-0 px-1">
      <v-row class="item-content">
        <div v-if="cat.ID == -1">
          {{ $t("chef_recommendation") }}
        </div>
        <div v-else-if="cat.ID == -2 && $store.state.pointRedeemEnabled">
          {{ $t("redeemable_category") }}
        </div>
        <div v-else>
          <div v-if="$store.state.descrIndex == 0">
            {{ cat.descr }}
            <div v-if="cat.detail != ''" class="item-detail">
              {{ cat.detail }}
            </div>
          </div>

          <div v-if="$store.state.descrIndex == 1">
            {{ cat.descr1 }}
            <div v-if="cat.detail != ''" class="item-detail">
              {{ cat.detail1 }}
            </div>
          </div>

          <div v-if="$store.state.descrIndex == 2">
            {{ cat.descr2 }}
            <div v-if="cat.detail != ''" class="item-detail">
              {{ cat.detail2 }}
            </div>
          </div>
        </div>
      </v-row>
    </v-col>

    <v-col
      v-if="
        $store.state.menuImageAlignment == 'right' &&
          ($store.state.menuImageVisible == 'show' || ($store.state.menuImageVisible == 'auto' && cat.imageUri != ''))
      "
      class="menu-img-box pa-0"
    >
      <div v-if="cat.imageUri == '' && (cat.imageUris === undefined || cat.imageUris.length == 0)"></div>
      <div v-else>
        <img v-if="cat.imageUri !== undefined && cat.imageUri != ''" :src="cat.imageUri" />
        <div v-else-if="cat.imageUris !== undefined && cat.imageUris.length > 0">
          <v-carousel
            cycle
            :show-arrows="false"
            :interval="10000 + Math.floor(Math.random() * 10) * 1000"
            hide-delimiter-background
            hide-delimiters
          >
            <v-carousel-item
              :x-transition="Math.floor(Math.random() * 2) % 2 == 0 ? 'slide-x-transition' : 'slide-y-transition'"
              :transition="Math.floor(Math.random() * 2) % 2 == 0 ? 'slide-x-transition' : 'slide-y-transition'"
              v-for="(imageUri, imgIndex) in cat.imageUris"
              :key="imgIndex"
            >
              <img :src="imageUri" />
            </v-carousel-item>
          </v-carousel>
        </div>
        <div v-else></div>
      </div>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    cat: null,
  },

  methods: {
      categoryClicked(cat) {
          this.$emit("categoryClicked", cat);
      }
  },
};
</script>

<style lang="scss" scoped>
@import "@/sass/variables.scss";

.v-slide-group__prev {
  min-width: 30px;
}

.v-slide-group__next {
  min-width: 30px;
}
</style>
